import React, { useState } from "react";
import { Styles } from "../award-event/styles/awardEvent";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../components/Footer";
import "./styles/event-common.css";

const Event18 = () => {
  const embedUrl1 = `https://www.youtube.com/embed/6Vs9sAXnepg`;

  const embedUrl2 = `https://www.youtube.com/embed/LHrykRTkRmI`;

  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper event-page">
        {/* Header 2 */}
        <Header />

        {/* Breadcroumb */}
        <BreadcrumbBox title="Event" img="16_5.jpeg" />
        <Container>
          <Row>
            <Col>
              <a
                href="/news"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  lineHeight: "40px",
                }}
              >
                Back To News
              </a>
            </Col>
          </Row>
        </Container>

        {/* News Area */}
        <section className="award-page">
          <Container>
            <Row>
              <Col md="12">
                <div style={{ padding: "20px 0" }}>
                  <h2
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "black",
                    }}
                  >
                    বিশ্ব টয়লেট দিবস ২০২৫: হারপিক আয়োজনে SDG 6.2 অর্জনে সরকার–বেসরকারি সমন্বয়ের আহ্বান
                  </h2>



                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "20px 0",
                    }}
                  >
                    বিশ্ব টয়লেট দিবস ২০২৫ উপলক্ষ্যে হারপিক আয়োজিত বিশেষ অনুষ্ঠানে উপস্থিত ছিলেন CWIS–FSM Support Cell,জনস্বাস্থ্য প্রকৌশল অধিদপ্তরের Chief Operating Officer ড. আব্দুল্লাহ আল-মুয়ীদ। অনুষ্ঠানে তিনি নিরাপদ স্যানিটেশন ও স্বাস্থ্যসম্মত টয়লেট ব্যবস্থার গুরুত্ব তুলে ধরে SDG 6.2 অর্জনে জাতীয় পর্যায়ে সমন্বিত উদ্যোগ জোরদারের অঙ্গীকার ব্যক্ত করেন।

                    ড. আল-মুয়ীদ বলেন, “সবার জন্য নিরাপদ স্যানিটেশন নিশ্চিত করতে সরকার, বেসরকারি খাত, উন্নয়ন অংশীদার ও সামাজিক সংগঠনগুলোর সম্মিলিত প্রচেষ্টা অপরিহার্য। টেকসই স্যানিটেশন কেবল অবকাঠামো নয়—এটি জনস্বাস্থ্য, পরিবেশ সুরক্ষা ও মর্যাদার প্রশ্ন।” তিনি CWIS ও FSM কাঠামোর মাধ্যমে শহর ও গ্রামীণ পর্যায়ে অন্তর্ভুক্তিমূলক সমাধান বাস্তবায়নের প্রয়োজনীয়তার ওপর জোর দেন।

                    অনুষ্ঠানে হারপিকের প্রতিনিধিরা স্বাস্থ্যকর টয়লেট ব্যবস্থাপনা ও আচরণগত পরিবর্তনে সচেতনতা তৈরির নানা উদ্যোগ তুলে ধরেন। বক্তারা একমত পোষণ করেন যে, উদ্ভাবন, নীতিগত সহায়তা ও মাঠপর্যায়ের বাস্তবায়নের সমন্বয়ই দেশকে নিরাপদ স্যানিটেশনের লক্ষ্যে এগিয়ে নেবে।


                    <br /><br />
                    <div style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}}>
                      Video Link (Part 1):
                    {/* <a
                      href="https://youtube.com/shorts/6Vs9sAXnepg?feature=share"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://youtube.com/shorts/6Vs9sAXnepg?feature=share
                    </a> */}
                    <div className="video-responsive" style={{ height: '500px', width: '300px' }}>
                      <iframe
                        width="100%"
                        height="100%"
                        src={embedUrl1}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="YouTube Short"
                      />
                    </div>
                    <br />
                    Video Link (Part 2):
                    {/* <a
                      href="https://youtube.com/shorts/LHrykRTkRmI?feature=share"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://youtube.com/shorts/LHrykRTkRmI?feature=share
                    </a> */}
                    <div className="video-responsive" style={{ height: '500px', width: '300px' }}>
                      <iframe
                        width="100%"
                        height="100%"
                        src={embedUrl2}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="YouTube Short"
                      />
                    </div>
                    </div>
                  </p>

                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </Styles>
  );
};

export default Event18;
